import { SelectInput, ReferenceInput, ReferenceInputProps } from 'react-admin';
import { TurnReferencesEnum } from '@/types/turn-enums';
import { PER_PAGE, SORT_OPTIONS } from './constants';
import { StateInputProps } from './types';

const StateInput = ({
  disabled,
  label = 'State',
  filter = {},
  include_prefix = true,
  source,
  validate,
  ...props
}: StateInputProps) => {
  const computedFilter = { ...filter };

  if (!include_prefix) computedFilter.include_prefix = 'False';

  return (
    <ReferenceInput
      filter={computedFilter}
      perPage={PER_PAGE}
      reference={TurnReferencesEnum.AdminStates}
      sort={SORT_OPTIONS}
      source={source}
      {...props}
    >
      <SelectInput
        disabled={disabled}
        label={label}
        optionText="name"
        optionValue="id"
        translateChoice={false}
        validate={validate}
      />
    </ReferenceInput>
  );
};

export default StateInput;
